import {
  TableLayout,
  TableLayoutActions,
  TableLayoutFilters,
  TableLayoutSearchInput,
  TableLayoutTable,
} from 'src/common/components/Layouts/TableLayout/TableLayout';
import { TariffSummaryInventory } from './Inventory/TariffSummaryInventory';
import { AccountSingleSearchFilter } from 'src/common/components/Filters/Inputs/accounts/AccountSingleSearchFilter';
import { accountsTariffSummaryAtom } from 'src/atoms/filters/tariff-summary';
import { useIsCslUser } from 'src/auth/hooks/useIsCslUser';
import { RefetchQueryButton } from 'common/components/Queries/RefetchQueryButton.tsx';
import { tariffSummaryQueries } from './Inventory/queries/tariffSummaryQueries';
import { ContentBox } from 'src/common/components/AppLayout/ContentBox';
import { TableSkeleton } from 'src/common/components/Table/TableSkeleton';
import { useSetAtom } from 'jotai';
import {
  tariffSummaryAccountsHintsAtom,
  tariffSummaryUpdateHintsAtom,
} from 'src/atoms/hints/tariff-summary';
import { TariffSummaryAlertsToolbar } from './Inventory/components/TariffSummaryAlertsToolbar';
import { Suspense } from 'react';

export const TariffSummary = () => {
  const isCslUser = useIsCslUser();
  const setHints = useSetAtom(tariffSummaryUpdateHintsAtom);

  return (
    <TableLayout firstTab>
      <>
        <TableLayoutFilters>
          {isCslUser && (
            <TableLayoutSearchInput>
              <AccountSingleSearchFilter
                accountsFilterAtom={accountsTariffSummaryAtom}
                accountsHintsAtom={tariffSummaryAccountsHintsAtom}
                onAccountSelected={(option) => {
                  if (option !== null && option.id !== null) {
                    setHints({ accounts: [option.id] });
                  }
                }}
              />
            </TableLayoutSearchInput>
          )}
          <TariffSummaryAlertsToolbar />
        </TableLayoutFilters>

        <TableLayoutActions>
          <RefetchQueryButton queryKey={tariffSummaryQueries.all} />
        </TableLayoutActions>
      </>
      <TableLayoutTable>
        <Suspense
          fallback={
            <ContentBox>
              <TableSkeleton showStartSkeleton numberOfRows={20} />
            </ContentBox>
          }
        >
          <TariffSummaryInventory />
        </Suspense>
      </TableLayoutTable>
    </TableLayout>
  );
};
